import React from "react";
import CheckInAddition from "./CheckInAddition";

const Checkins = (props) => {
    let locations = (typeof props.data.locations !== 'undefined'?props.data.locations:null);
    let element = <CheckInAddition
        checkins={props.reservation.checkins}
        id={props.reservation.id}
        order_id={props.reservation.order_id}
        app_user_role={props.data.app_user_role}
        reservation={props.reservation}
        dispatch={props.data.dispatch}
        checkout={props.data.checkout}
        setCheckout={props.data.setCheckout}
        setCheckoutReservation={props.data.setCheckoutReservation}
        setCheckoutCheckin={props.data.setCheckoutCheckin}
        setFilter={props.data.setFilter}
        filter={props.data.filter}
        setNKey={props.data.setNKey}
        sort={props.data.sort}
        setSort={props.data.setSort}
        _key={props.data._key}
        locations={locations}
        key={"checkin_addition_"+props.reservation.id}
    />;
       return <>{props.panel ? <>
            <div id={"checkins-panel-" + props.reservation.id}
                 className="inb-c-item-details inb-c-order-reservations row">
                {element}
            </div>
        </>:
            element
        }
    </>;
}

export default Checkins;